export default "__VITE_ASSET__DJ4QviJH__"